import React from 'react';

import Form from 'src/components/forms/form';
import { yup } from 'shared/core/yup';
import { StepHeader, StepPanel, StepFooter } from '../shared-components';
import { GoodCannaFooter, FormTextInput, FormFormattedInput, SubmitButton } from './med-intake-ui';

// Personal Information schema
export const personalInfoSchema = yup.object().shape({
  driversLicense: yup.string().default('').required('Driver license number is required'),
  firstName: yup.string().default('').required('First name is required'),
  lastName: yup.string().default('').required('Last name is required'),
  dateOfBirth: yup.string().default('').required('Date of birth is required'),
  email: yup.string().default('').email('Invalid email address').required('Email is required'),
  phone: yup
    .string()
    .default('')
    .required('Phone number is required')
    .test('is-valid-phone', 'Please enter a valid 10-digit US phone number', (value) => {
      if (!value) {
        return false;
      }
      // Remove all non-digit characters
      const digitsOnly = value.replace(/\D/g, '');
      return digitsOnly.length === 10;
    }),
});

export type PersonalInfoFieldsType = yup.InferType<typeof personalInfoSchema>;

type PersonalInformationStepProps = {
  onNext: (data: { personalInfo: PersonalInfoFieldsType }) => void;
  onBack: () => void;
  defaultValues?: PersonalInfoFieldsType;
};

export const PersonalInformationStep = ({
  onNext,
  onBack,
  defaultValues,
}: PersonalInformationStepProps): JSX.Element => {
  const handleSubmit = (data: PersonalInfoFieldsType): void => {
    onNext({ personalInfo: data });
  };

  return (
    <>
      <StepHeader
        onBack={onBack}
        showBackButton={false}
        stepHeading='Personal Information'
        stepDescription='Providing accurate personal information is essential to ensure your ceritification process goes smoothly.'
      />
      <Form onSubmit={handleSubmit} validationSchema={personalInfoSchema} defaultValues={defaultValues}>
        <StepPanel>
          <FormTextInput name='driversLicense' label='Driver License Number' />
          <FormTextInput name='firstName' label='First Name' />
          <FormTextInput name='lastName' label='Last Name' />
          <FormFormattedInput name='dateOfBirth' label='Date of Birth' format='date' />
          <FormTextInput name='email' label='Email' />
          <FormFormattedInput name='phone' label='Phone' format='phone' />
        </StepPanel>
        <StepFooter>
          <SubmitButton>Looks Good</SubmitButton>
          <GoodCannaFooter />
        </StepFooter>
      </Form>
    </>
  );
};
